import { Component, Input } from "@angular/core";
import { BaseComponent } from "../../../base.component";
import { SelectArea } from "../../../_models/index";
import {
  Form,
  NgForm,
  FormControl,
  FormGroup,
  FormBuilder,
  Validators,
  ValidatorFn,
} from "@angular/forms";
import * as _ from "lodash";
import { SessionManagerService } from "../../../_services/SessionManager/session-manager.service";
import { DataService } from "../../../_services/data.service";
import { AlertService } from "../../../_services/alert.service";

@Component({
  moduleId: module.id,
  selector: "boolean",
  templateUrl: "boolean.component.html",
  styleUrls: ["./boolean.component.css"],
})
export class BooleanComponent extends BaseComponent {
  @Input() form: NgForm;
  @Input() controlName: string;
  @Input() value?: any;
  @Input() label: string;
  formGroupObj: FormGroup;

  constructor(
    public dataService: DataService,
    private alertService: AlertService,
    public sessionManager: SessionManagerService
  ) {
    super(dataService, sessionManager);
  }

  run() {
    this.formGroupObj = new FormGroup({});

    this.formGroupObj.addControl(
      this.controlName,
      new FormControl(this.value ? true : false, null)
    );
  }

  clickButton(e) {
    this.formGroupObj.controls[this.controlName].patchValue(
      !this.formGroupObj.controls[this.controlName].value
    );
    e.preventDefault();
    e.stopPropagation();
  }

  isActive() {
    return this.formGroupObj.controls[this.controlName].value;
  }

  submit() {
    // 		if (this.form.submitted)
    return this.formGroupObj.getRawValue();
    // 		else
    // 			return;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/components/boolean/boolean.component.ts